<!--
 * @Author: 王豫龙 sanyang010325@gmail.com
 * @Date: 2025-04-18 09:22:56
 * @LastEditors: 王豫龙 sanyang010325@gmail.com
 * @LastEditTime: 2025-04-23 16:21:09
 * @FilePath: \VueBlogger-main\src\components\Footer.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="footer">
    <div class="container text-center">
      <h3>{{ config.blogTitle }}</h3>
      <p><i>{{ config.description }}</i></p>
      <br />
      <p v-if="curYear === config.blogStartYear">
        &copy; {{ curYear }} {{ config.name }}.&nbsp;
        <a
        style="color: black"
        href ="https://beian.miit.gov.cn/"
        target="_blank"
        rel="noopener noreferrer"
        >
          豫ICP备2023023984号
        </a>
        &nbsp;&nbsp;
        <a
        style="color: black"
        href ="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=41052202001412"
        target="_blank"
        rel="noopener noreferrer"
        >
        <img src="https://wandh.cn/static/image/jinghui.png" style="width: 15px; height: 15px;">
          豫公网安备41052202001412号
        </a>
      </p>
      <p v-else>
        &copy; {{ config.blogStartYear }} - {{ curYear }} {{ config.name }}.&nbsp;
        <a
        style="color: black"
        href ="https://beian.miit.gov.cn/"
        target="_blank"
        rel="noopener noreferrer"
        >
          豫ICP备2023023984号
        </a>
        <a
        style="color: black"
        href ="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=41052202001412"
        target="_blank"
        rel="noopener noreferrer"
        >
        <img src="https://wandh.cn/static/image/jinghui.png" style="width: 15px; height: 15px;">
          豫公网安备41052202001412号
        </a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data: function () {
    return {
      config: this.getConfig().config,
      curYear: new Date().getFullYear()
    }
  },
  methods: {
    getYear: function () {
      return new Date().getFullYear()
    }
  }
}
</script>
